<template>
  <div class="ad">
    <h2>广告</h2>
    <div class="normal">
      广告名称：
      <div class="inputBox">
        <el-input v-model="ad_name"></el-input>
      </div>
    </div>
    <div class="normal">
      广告跳转：
      <el-radio v-model="goto" label="楼盘页面">楼盘页面</el-radio>
      <el-radio v-model="goto" label="文章页面">文章页面</el-radio>
      <el-radio v-model="goto" label="销售个人">销售个人</el-radio>
      <el-radio v-model="goto" label="小程序">小程序</el-radio>
      <!-- <el-radio v-model="goto" label="楼盘组团">楼盘组团</el-radio> -->
      <el-radio v-model="goto" label="品牌馆">品牌馆</el-radio>
      <el-radio v-model="goto" label="合集">合集</el-radio>
      <el-radio v-model="goto" label="装修活动">装修活动</el-radio>
    </div>
    <div class="normal" v-if="goto === '楼盘页面'">
      广告楼盘：
      <el-select
        v-model="toRealPage"
        filterable
        placeholder="选择楼盘"
        default-first-option
        :remote-method="searchEstate"
        remote
        clearable
        ref="adSelect2"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
      >
        <el-option
          v-for="item in matchEstates"
          :key="item.id"
          :label="item.real_estate_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="normal" v-if="goto === '销售个人'">
      跳转销售：
      <el-select
        v-model="sale_id"
        filterable
        placeholder="搜索姓名"
        default-first-option
        ref="adSelect3"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
        :remote-method="chooseSale"
        remote
      >
        <el-option
          v-for="item in saleList"
          :key="item.id"
          :label="item.user_name + '(' + item.user_type + ')'"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="normal" v-if="goto === '装修活动'">
      活动品牌商：
      <el-select
        v-model="pinpai_id"
        filterable
        placeholder="搜索品牌名"
        default-first-option
        ref="adSelect7"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
        :remote-method="choosePinpai"
        remote
      >
        <el-option
          v-for="item in pinpaiList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="act_id"
        filterable
        placeholder="搜索活动名"
        default-first-option
        ref="adSelect8"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
        :remote-method="chooseAct"
        remote
      >
        <el-option
          v-for="item in activityList"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <!-- <div class="normal" v-if="goto === '楼盘页面'">跳转类别：
      <el-radio label="R" v-model="jump">普通</el-radio>
      <el-radio label="B" v-model="jump">自家的</el-radio>
      <el-radio label="T" v-model="jump">预约登记页</el-radio>
    </div> -->
    <div class="normal" v-if="goto === '文章页面'">
      <div class="normal">
        跳转文章：
        <div class="inputBox">
          <el-input v-model="toArtical"></el-input>
        </div>
      </div>
    </div>
    <!-- <div class="normal">排序权重：
      <div class="inputBox">
        <el-input v-model="weight" type="number"></el-input>
      </div>
    </div> -->
    <div
      class="normal"
      v-if="isAdmin && ['开屏广告', '首页顶部'].includes(type)"
    >
      目标曝光量：
      <div class="inputBox">
        <el-input v-model="goal" type="number"></el-input>
      </div>
    </div>

    <div class="normal">
      广告位置：
      <el-select
        v-model="type"
        placeholder="请选择"
        ref="adSelect4"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
      >
        <el-option
          v-for="item in types"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>

    <div class="normal" v-if="goto === '楼盘组团' || type === '上竞品的楼盘页'">
      <span v-if="type === '上竞品的楼盘页'">竞品楼盘：</span>
      <span v-else>楼盘组团：</span>
      <div v-for="(estate, index) in estates" :key="estate.id">
        <span>{{ estate.real_estate_name }}</span>
        <button @click="estates.splice(index, 1)">删除</button>
      </div>
      <el-select
        v-model="chooseId"
        filterable
        placeholder="选择楼盘"
        default-first-option
        ref="adSelect1"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
        :remote-method="searchEstate"
        remote
        clearable
        @change="addEstate"
      >
        <el-option
          v-for="item in matchEstates"
          :key="item.id"
          :label="item.real_estate_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="normal" v-if="goto === '品牌馆'">
      <el-select
        v-model="brand_id"
        filterable
        placeholder="选择品牌馆"
        default-first-option
        ref="adSelect5"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
        :remote-method="searchBrand"
        remote
        clearable
      >
        <el-option
          v-for="item in brandList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="normal" v-if="goto === '合集'">
      <el-select
        v-model="collect_id"
        filterable
        placeholder="选择合集"
        default-first-option
        ref="adSelect6"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
        :remote-method="searchCollect"
        remote
        clearable
      >
        <el-option
          v-for="item in collectList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="normal" v-if="!noImage.includes(type)">
      广告图片
      <div class="normal">
        <input id="ad" type="file" @change="chooseImageCompress" />
      </div>
      <div class="normal">
        <img
          class="adImg"
          :src="adImgUrl"
          alt=""
          preview="6"
          preview-text="广告图"
        />
      </div>
    </div>

    <div v-if="type === '亚运活动'" class="radio-group">
      展位权重：
      <el-radio-group v-model="weight">
        <el-radio :label="4.3">一档(4)</el-radio>
        <el-radio :label="2">二档(2)</el-radio>
        <el-radio :label="1">三档(1)</el-radio>
      </el-radio-group>
    </div>
    <div v-if="goto === '楼盘组团'" class="normal">
      组团海报
      <div class="normal">
        <input id="group" type="file" @change="chooseImage" />
      </div>
      <div class="normal">
        <img
          class="groupImg"
          :src="groupImgUrl"
          alt=""
          preview="6"
          preview-text="广告图"
        />
      </div>
    </div>
    <el-select
      v-model="status"
      filterable
      placeholder="选择上传版本"
      default-first-option
    >
      <el-option
        v-for="item in statuslist"
        :key="item"
        :label="item"
        :value="item"
      >
      </el-option>
    </el-select>
    <el-date-picker
      v-model="date_range"
      type="datetimerange"
      value-format="yyyy-MM-dd HH:mm:ss"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :default-time="['00:00:00', '23:59:59']"
    >
    </el-date-picker>

    <div class="normal">
      <el-button @click="upToDb" type="primary">上传</el-button>
    </div>
  </div>
</template>

<script>
import adPosition from "../config/adPosition";
const { value2show } = adPosition;
export default {
  data() {
    return {
      ad_id: "",
      toArtical: "", // 跳转到文章的链接
      toRealPage: "", // 跳转到楼盘的id
      ad_name: "",
      adImgUrl: "",
      type: "",
      goto: "楼盘页面",
      pinpai_id: "",
      types: [],
      matchEstates: [],
      noImage: [
        "搜索框",
        "预售推荐",
        "评测推荐",
        "热门推荐",
        "预计开盘置顶",
        "开屏底部",
        "搜索置顶",
        "首页猜你喜欢",
        "近期拿证置顶",
        "1v1服务弹窗",
        "上竞品的楼盘页",
        "公寓置顶",
        "特惠楼盘置顶",
        "首页点击榜楼盘推荐",
        "首页热搜榜楼盘推荐",
        "首页中签榜楼盘推荐",
        "首页倒挂榜楼盘推荐",
        "首页产业榜楼盘推荐",
        "首页配套榜楼盘推荐",
        "首页日照噪声榜楼盘推荐",
        "首页规划榜楼盘推荐",
        "地铁找房置顶",
      ],
      jump: "R",
      modelMap: {
        杭州: "WpAdModel",
        苏州: "SzAdModel",
        天津: "TjAdModel",
        绍兴: "SxAdModel",
        宁波: "NbAdModel",
      },
      weight: 1,

      sale_id: "",
      saleList: [],
      estates: [],
      chooseId: "",
      groupImgUrl: "",

      date_range: [], // 广告展示起止日期

      isAdmin: false,
      goal: "",

      brand_id: "",
      brandList: [],

      collect_id: "",
      collectList: [],
      pinpaiList: [],
      act_id: "",
      activityList: [],
      statuslist: ["正式版", "测试版"],
      status: "正式版",
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "login") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      let origin = this.$options.data();
      Object.assign(this.$data, origin);
      this.init();
    }
    this.$route.meta.isBack = false;
  },
  methods: {
    init() {
      let that = this;
      let obj = that.$route.params;

      // 初始化types
      const types = Object.keys(value2show);
      types.push("品牌馆");
      this.types = types;

      if (obj.id) {
        that.$axios
          .get(that.$url_prefix + "queryOneById", {
            params: {
              id: obj.id,
              db: that.modelMap[that.$store.state.Counter.city],
            },
          })
          .then(function (res) {
            let theAd = res.data.data;
            console.log("theAd", theAd);
            that.ad_id = theAd.id;
            that.adImgUrl = theAd.ad_img || "";
            that.groupImgUrl = theAd.group_img || "";
            that.ad_name = theAd.ad_name || "";
            that.weight = theAd.weight || 1;
            that.status = theAd.status == "test" ? "测试版" : "";
            that.goal = theAd.goal || "";
            that.estates = theAd.estates || [];
            that.brandList = theAd.brandList || [];
            that.brand_id = theAd.ad_url.split("=")[1];
            that.act_id = theAd.ad_url.split("=")[1];
            if (theAd.ad_url && theAd.ad_url.includes("=")) {
              let arr = theAd.ad_url.split("=");
              if (["R", "T", "B"].includes(arr[0])) {
                that.jump = arr[0];
                that.toRealPage = arr[1];
                that.goto = "楼盘页面";
              } else if (arr[0] === "A") {
                that.toArtical = arr[1];
                that.goto = "文章页面";
              } else if (arr[0] === "M") {
                that.goto = "小程序";
              } else if (arr[0] === "S") {
                that.sale_id = arr[1];
                that.goto = "销售个人";
              } else if (arr[0] === "Z") {
                that.goto = "楼盘组团";
              } else if (arr[0] === "P") {
                that.goto = "品牌馆";
              } else if (arr[0] === "COLL") {
                that.goto = "合集";
              } else if (arr[0] === "ZXHD") {
                that.goto = "装修活动";
              }
            }
            that.type = theAd.type || "";
            that.matchEstates = theAd.matchEstates;
            that.saleList = theAd.saleList;
            if (theAd.start_time && theAd.end_time) {
              that.date_range = [theAd.start_time, theAd.end_time];
            }
            that.isAdmin = theAd.isAdmin;
          })
          .catch(function (res) {
            console.log("queryAd fail", res);
            that.$message.error("查询失败, 请检查网络");
          });
      }
    },

    //选择图片
    chooseImage(event) {
      let that = this;
      let option = {
        file: event.target.files[0],
        head_name: "ad",
      };
      that
        .$uploadImage(option)
        .then(function (res) {
          console.log("upload back", res);
          if (!res) {
            console.log("upload fail");
            return;
          }
          if (event.target.id === "ad") {
            that.adImgUrl = res;
          } else {
            that.groupImgUrl = res;
          }
          that.$previewRefresh();
        })
        .catch(function (res) {
          console.log("upload fail", res);
        });
    },
    chooseImageCompress(event) {
      let that = this;
      let option = {
        file: event.target.files[0],
        head_name: "ad",
      };
      that
        .$uploadImageCompress(option)
        .then(function (res) {
          console.log("upload back", res);
          if (!res) {
            console.log("upload fail");
            return;
          }
          if (event.target.id === "ad") {
            that.adImgUrl = res;
          } else {
            that.groupImgUrl = res;
          }
          that.$previewRefresh();
        })
        .catch(function (res) {
          console.log("upload fail", res);
        });
    },

    //上传数据库
    upToDb() {
      let that = this;
      if (!that.ad_name) {
        that.$message.error("广告名称必填");
        return;
      }
      if (
        that.noImage.includes(that.type) ||
        that.type.includes("楼盘推荐") ||
        that.type.includes("评测位置")
      ) {
        if (!that.toRealPage && that.goto === "楼盘页面") {
          that.$message.error("请选择楼盘");
          return;
        }
      } else if (!that.adImgUrl) {
        that.$message.error("请上传广告图片");
        return;
      }

      let date_range = that.date_range;

      let obj = {};
      if (that.ad_id) {
        obj.id = that.ad_id;
      }
      if (that.goto === "楼盘页面") {
        obj.ad_url = that.jump + "=" + that.toRealPage;
      } else if (that.goto === "文章页面") {
        obj.ad_url = "A=" + that.toArtical;
      } else if (that.goto === "销售个人") {
        if (!that.sale_id) {
          that.$message.error("请选择销售");
          return;
        }
        obj.ad_url = "S=" + that.sale_id;
      } else if (that.goto === "楼盘组团") {
        obj.ad_url = "Z=" + (obj.estates[0] || "");
      } else if (that.goto === "品牌馆") {
        if (!that.brand_id) {
          that.$message.error("请选择品牌馆");
          return;
        }
        obj.ad_url = "P=" + that.brand_id;
      } else if (that.goto === "合集") {
        if (!that.collect_id) {
          that.$message.error("请选择合集");
          return;
        }
        obj.ad_url = "COLL=" + that.collect_id;
      } else if (that.goto === "装修活动") {
        if (!that.act_id) {
          this.$message.error("请选择活动");
          return;
        }
        obj.ad_url = "ZXHD=" + that.act_id;
      } else {
        obj.ad_url = "M=";
      }
      obj.estates = that.estates.map((x) => x.id);
      obj.ad_img = that.adImgUrl;
      obj.group_img = that.groupImgUrl;
      obj.type = that.type;
      obj.ad_name = that.ad_name;
      obj.weight = that.weight;
      obj.goal = that.goal;
      obj.start_time = date_range[0] || "";
      obj.end_time = date_range[1] || "";
      obj.status = that.status == "正式版" ? "" : "test";
      if (that.noImage.includes(that.type) && that.goto === "楼盘页面") {
        obj.data = that.matchEstates.find((x) => {
          return x.id === that.toRealPage;
        });
      }
      let param = {
        db: that.modelMap[that.$store.state.Counter.city],
        model: "edit",
        item: JSON.stringify(obj),
      };
      // console.log("🚀 ~ file: ad.vue:406 ~ upToDb ~ param:", param)
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          console.log("发送返回", res);
          if (res.data.success) {
            that.$router.push({
              path: "/IndexPage",
            });
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(function (res) {
          console.log("上传失败", res);
        });
    },

    searchEstate(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "searchEstateName", {
            params: {
              search: search,
            },
          })
          .then((res) => {
            that.matchEstates = res.data.data;
          });
      }
    },

    chooseSale(search) {
      let that = this;
      if (search) {
        that.$axios
          .get(that.$url_prefix + "getSalesName", {
            params: {
              search: search,
            },
          })
          .then((res) => {
            that.saleList = res.data.data;
          });
      }
    },
    choosePinpai(search) {
      let that = this;
      if (search) {
        that.$axios
          .post(that.$url_prefix + "fitment/get/brand/list", {
            params: {
              keyword: search,
            },
          })
          .then((res) => {
            that.pinpaiList = res.data.data.list;
          });
      }
    },
    chooseAct(search) {
      let that = this;
      that.activityList = [];
      console.log(this.pinpai_id);
      if (search) {
        that.$axios
          .post(that.$url_prefix + "fitment/get/activity/list", {
            params: {
              keyword: search,
            },
          })
          .then((res) => {
            console.log(res);
            let list = res.data.data.list;
            for (let index = 0; index < list.length; index++) {
              const element = list[index];
              if (!this.pinpai_id || this.pinpai_id == element.brand_id) {
                that.activityList.push(element);
              }
            }
          });
      }
    },
    addEstate(e) {
      let find = this.estates.find((x) => x.id === e);
      if (!find) {
        let one = this.matchEstates.find((x) => x.id === e);
        if (one) {
          this.estates.push(one);
        }
      }
    },

    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const Selects = this.$refs;
          if (Selects.adSelect1) {
            const input =
              Selects.adSelect1.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
          if (Selects.adSelect2) {
            const input =
              Selects.adSelect2.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
          if (Selects.adSelect3) {
            const input =
              Selects.adSelect3.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
          if (Selects.adSelect4) {
            const input =
              Selects.adSelect4.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
          if (Selects.adSelect5) {
            const input =
              Selects.adSelect5.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
          if (Selects.adSelect6) {
            const input =
              Selects.adSelect6.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
          if (Selects.adSelect7) {
            const input =
              Selects.adSelect7.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
          if (Selects.adSelect8) {
            const input =
              Selects.adSelect8.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }
        }
      });
    },

    searchBrand(search) {
      this.$axios
        .get(this.$url_prefix + "searchBrand", {
          params: {
            search: search,
          },
        })
        .then((res) => {
          this.brandList = res.data.data;
        });
    },
    searchCollect(search) {
      this.$axios
        .get(this.$url_prefix + "searchCollection", {
          params: {
            search: search,
          },
        })
        .then((res) => {
          this.collectList = res.data.data;
        });
    },
  },
};
</script>

<style scoped>
.ad {
  text-align: center;
  overflow: hidden;
}

h2 {
  margin-top: 50px;
}

.adImg {
  height: 100px;
}

.inputBox {
  display: inline-block;
}
.radio-group {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/ad.vue